export enum FormKeys {
    DeliveryTypeCategory = 'deliveryTypeCategory',
    Customer = 'customer',
    DeliveryTime = 'deliveryTime',
    Note = 'note',
    AutomaticContainerRemovals = 'automaticContainerRemovals',
}

export enum FormCustomerKeys {
    Phone = 'phone',
    Name = 'name',
    Address = 'address',
}
